import { render, staticRenderFns } from "./DeviceManagementModifyJigouPlLiang.vue?vue&type=template&id=673c94a0&scoped=true&"
import script from "./DeviceManagementModifyJigouPlLiang.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementModifyJigouPlLiang.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagementModifyJigouPlLiang.vue?vue&type=style&index=0&id=673c94a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c94a0",
  null
  
)

export default component.exports